module.exports = __webpack_public_path__ + "static/rcc-os-badge-e7f2b986142d6ffc637509bebcd4bd75.png";